const dev = false;
const endpoint = dev ? `http://127.0.0.1:8787` : `https://wishlist.bedthreads.workers.dev`;

window.wishlist = {
    loggedIn: false,
    loaded: false,
    customer: '',
    dataKey: '',
    data: {
        version: 1,
        items: [],
        timestamp: 0
    },

    checkAvailability: async function() {
        if (!this.loaded) await this.reloadData();
        
        const itemsToCheck = [...this.data.items];
        const removedItems = [];
        
        // Create an array of promises for checking each item
        const checkPromises = itemsToCheck.map(item => {
            return fetch(`/products/${item.handle}`, {
                method: 'HEAD'
            })
            .then(response => {
                return { item, status: response.status, ok: response.ok };
            })
            .catch(error => {
                console.error(`Error checking availability for ${item.handle}:`, error);
                return { item, error: true };
            });
        });
        
        // Wait for all checks to complete in parallel
        const results = await Promise.all(checkPromises);
        
        // Process results and identify unavailable items
        const itemsToRemove = results
            .filter(result => !result.ok && result.status === 404)
            .map(result => result.item);
        
        // Remove unavailable items sequentially to avoid race conditions
        for (const item of itemsToRemove) {
            await this.remove(item.id);
            removedItems.push(item);
        }
        
        if (removedItems.length > 0) {
            // Dispatch event for removed items
            window.dispatchEvent(new CustomEvent('wishlistavailability', { 
                detail: { removedItems: removedItems } 
            }));
        }
        
        return removedItems;
    },

    load: function() {
        let serverData = null;
        let dataElem = document.getElementById('wishlistData');

        if (dataElem) {
            let json = JSON.parse(dataElem.innerHTML);
            this.serverData = json.data;
            this.customer = json.customer;
            this.loggedIn = true;
            this.dataKey = `btWishlist${this.customer}`;
        }
        else this.dataKey = 'btWishlist';

        this.lastSync = Date.now();
        this.reloadData();
    },

    hasItem: function(id) {
        return this.data.items.find(i => i.id == id) != undefined;
    },

    getItem: function(id) {
        return this.data.items.find(i => i.id == id);
    },

    getItems: function() {
        return this.data.items;
    },

    reloadData: async function() {
        let storedData = JSON.parse(localStorage.getItem(this.dataKey));

        if (this.loggedIn) {
            if (Date.now() - this.lastSync > 1000 * 60 * 5) {
                // Fetch latest server data from backend
                let resp = await fetch('/pages/wishlist?view=wishlist-data');
                let json = await resp.json();
                this.serverData = json.data;
                this.lastSync = Date.now();
            }

            // Replace local data with fetched data if timestamp is newer, or if there is no data in localStorage
            if (this.serverData && (!storedData || this.serverData.timestamp > storedData.timestamp)) this.data = this.serverData;
            else if (storedData) this.data = storedData;

            // Migrate data from non-logged in user
            let guestData = JSON.parse(localStorage.getItem('btWishlist'));
            if (guestData && guestData.items && guestData.items.length > 0)  {
                for (let item of guestData.items) {
                    if (this.hasItem(item.id)) continue;
                    this.data.items.unshift({...item});
                }

                this.save();
                localStorage.removeItem('btWishlist');
            }
        }
        else if (storedData) this.data = storedData;
        this.loaded = true;
    },

    add: async function(item, index = undefined) {
        let {id, handle} = item;
        await this.reloadData();
        if (!this.hasItem(id)) {
            if (index) this.data.items.splice(index, 0, item);
            else this.data.items.unshift({...item});

            if (!item.isByob) {
                window.dispatchEvent(new CustomEvent('wishlistadd', { detail: { item: item } }));
                
                let fetches = this.data.items
                    .filter(item => !item.isByob)
                    .map(item => fetch(`/products/${item.handle}?view=klaviyo-wishlist-event`).then(resp => resp.json()));

                Promise.all(fetches).then(results => {
                    let current = results.find(res => res.ProductID == id);
                    window.klaviyo.track('Added to wishlist', {
                        ...current,
                        Wishlist: results
                    });
                });
            }

            fetch(`${endpoint}/track?handle=${item.handle}`, { mode: 'no-cors' });
        }
        await this.save();
    },

    update: async function(item) {
        await this.reloadData();
        let idx = this.data.items.findIndex(i => i.id == item.id);
        if (idx >= 0) {
            this.data.items[idx] = {...item};
            await this.save();
        }
    },

    addAll: async function(items, indexes = undefined) {
        await this.reloadData();
        console.log(items);
        for (let i = 0; i < items.length; i++) {
            if (this.hasItem(items[i].id)) continue;
            if (indexes) this.data.items.splice(indexes[i], 0, {...items[i]});
            else this.data.items.unshift({...items[i]});
        }
        await this.save();
    },

    remove: async function(id) {
        await this.reloadData();
        this.data.items = this.data.items.filter(i => i.id != id);
        window.dispatchEvent(new CustomEvent('wishlistremove', { detail: { id: id } }));
        await this.save();
    },

    clear: async function() {
        await this.reloadData();
        this.data.items = [];
        window.dispatchEvent(new CustomEvent('wishlistclear'));
        await this.save();
    },

    save: async function() {
        this.data.timestamp = Date.now();
        localStorage.setItem(this.dataKey, JSON.stringify(this.data));
        window.dispatchEvent(new Event('wishlistupdate'));

        if (this.loggedIn) {
            let payload = {
                store: theme.storeLocation,
                customer: this.customer,
                data: this.data
            };

            fetch(`${endpoint}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            window.klaviyo.identify({
                Wishlist: this.data.items.map(item => item.id)
            });
        }
    },

    hashCode: function() {
        let str = this.data.items.map(item => item.id).join(',');
        console.log(str);
        let hash = 0;
        for (let i = 0, len = str.length; i < len; i++) {
            let chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return Math.abs(hash).toString(36);
    }
}

class WishlistIcon extends HTMLElement {
    constructor() {
        super();
        this.prevCount = null;
        window.addEventListener('wishlistupdate', () => this.update());
    }

    connectedCallback() {
        setTimeout(() => this.update()); // Wait until child elements are parsed
    }

    update() {
        let count = wishlist.getItems().length;

        if (count == 0) this.classList.add('empty');
        else this.classList.remove('empty');

        if (this.prevCount != null && count > this.prevCount) {
            this.classList.add('added');
            if (this.prevCount == 0) this.classList.add('from-zero')
            setTimeout(() => {
                this.classList.remove('added');
                this.classList.remove('from-zero');
            }, 1000);
        }

        this.querySelector('.wishlist-count').innerHTML = count;
        this.prevCount = count;
    }
}

class WishlistAddButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.onClick);
        window.addEventListener('wishlistupdate', () => this.update());
    } 

    static get observedAttributes() {
        return ['data-variant'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'data-variant' && oldValue != newValue) wishlist.update({...this.dataset})
    }

    async connectedCallback() {
        // Fix for SearchSpring - wait until dataset.handle doesn't contain 'result.handle'
        while (this.dataset.handle.includes('result.handle')) {
            await new Promise(r => setTimeout(r, 100));
        }

        if (this.dataset.handle.includes('build-your-own')) return;

        this.viewHandler = null;
        this.id = this.dataset.id;
        this.setAttribute("role", "button");
        this.update();
        this.classList.add('loaded');
    }

    async onClick() {
        let initial = this.getBoundingClientRect().top;
        if (this.classList.contains('wishlist-add-button--has-label') && this.classList.contains('wishlist-add-button--view-wishlist')) return;
        this.classList.add('loading');
        if (wishlist.hasItem(this.id)) await wishlist.remove(this.id);
        else {
            await wishlist.add({...this.dataset});
            this.classList.add('added-anim');
            setTimeout(() => this.classList.remove('added-anim'), 500);
            if (this.classList.contains('wishlist-add-button--has-label')) {
                this.viewHandler = setTimeout(() => this.classList.add('wishlist-add-button--view-wishlist'), 5500);
            }
            
            const countText = this.querySelector('.wishlist-add-button__count');
            if (countText && this.dataset.count) countText.innerHTML = parseInt(this.dataset.count) + 1;
        }
        this.classList.remove('loading');
        let end = this.getBoundingClientRect().top;
        document.documentElement.scrollTop += end - initial;
    }

    update() {
        if (this.viewHandler) {
            clearTimeout(this.viewHandler);
            this.viewHandler = null
        }
        this.classList.remove('wishlist-add-button--view-wishlist');
        if (wishlist.hasItem(this.id)) {
            this.classList.add('added');
            if (this.classList.contains('wishlist-add-button--has-label')) 
            {
                this.querySelector('.wishlist-add-button__label').innerHTML = 'Added to Wishlist!'
            }
        }
        else {
            this.classList.remove('added');
            if (this.classList.contains('wishlist-add-button--has-label')) {
                this.querySelector('.wishlist-add-button__label').innerHTML = 'Add to Wishlist'
            }   
        }
    }
}

class WishlistItem extends HTMLElement {
    constructor() {
        super();
        this.onRemove = null;
        this.quantity = 1;

        this.addEventListener('variantchange', e => {
            if (e.detail) {
                let variant = e.detail.variant;
                // If size selected, update contents to reflect selected variant/size
                let atcButton = this.querySelector('button[name="add"]');
                let atcText = atcButton.querySelector('span.add');

                if (atcButton.dataset.variant != variant.id) {
                    this.classList.remove('added');
                    atcButton.dataset.variant = variant.id;
                }

                this.querySelector('.wishlist-item__price').innerHTML = variant.priceTextShort;

                atcButton.dataset.preorder = 'false';
                atcButton.dataset.soldOut = 'false';

                let link = this.querySelector('.wishlist-item__name a');
                // Replace variant ID in link, or append to end
                if (link.href.includes('?variant=')) link.href = link.href.replace(/variant=\d+/, `variant=${variant.id}`);
                else link.href += `?variant=${variant.id}`;

                if (this.dataset.variant != variant.id) {
                    this.dataset.variant = variant.id;
                    this.wishlistData.variant = variant.id;
                    wishlist.update({...this.dataset});
                }

                if (variant.status != 'available') {
                    if (variant.status === 'sold-out') {
                        atcText.innerHTML = 'Sold out';
                        atcButton.dataset.soldOut = 'true';
                    }
                    else if (variant.status === 'coming-soon') {
                        atcText.innerHTML = 'Coming soon';
                        atcButton.dataset.soldOut = 'true';
                    }
                    else {
                        atcText.innerHTML = 'Pre-order Now';
                        atcButton.dataset.preorder = 'true';
                        atcButton.dataset.preorderMonth = variant.preorderMonth;
                    }
                }
                else {
                    atcText.innerHTML = 'Add to Cart';
                }
            }
        });
    }

    async connectedCallback() {
        this.index = [...this.closest('wishlist-contents').querySelectorAll('.wishlist-item')].indexOf(this);
        this.id = this.dataset.id;
        this.handle = this.dataset.handle;
        this.isBundle = JSON.parse(this.dataset.isBundle);
        this.title = this.dataset.title;
        this.classList.add('data-loaded');

        this.wishlistData = {
            id: this.id,
            handle: this.handle,
            isBundle: this.isBundle,
            title: this.title
        }

        this.init();
    }

    // Get the info required to add to cart for this wishlist item
    getAtcInfo() {
        let button = this.querySelector('.wishlist-item__atc');

        return {
            handle: this.handle,
            variantId: button.dataset.variant,
            quantity: parseInt(this.querySelector('.wishlist-item__qty-count').innerHTML),
            isBundle: this.isBundle,
            preorderMonth: button.dataset.preorder === "true" ? button.dataset.preorderMonth : undefined
        }
    }

    async addToCart() {
        this.style.pointerEvents = 'none';
        let button = this.querySelector('.wishlist-item__atc');
        button.classList.add('show-loading');

        let atcInfo = this.getAtcInfo();

        await addToCartGlobal(
            atcInfo.handle, 
            atcInfo.variantId, 
            atcInfo.quantity,
            atcInfo.isBundle,
            atcInfo.preorderMonth
        );

        window.updateCartDrawer();

        let signifier = this.querySelector('.cart-signifier');
        signifier.classList.add('active');
        setTimeout(() => signifier.classList.remove('active'), 4000);

        button.classList.remove('show-loading');
        this.classList.add('added');
        this.dispatchEvent(new CustomEvent('wishlistitematc', {bubbles: true, detail: {item: this}}));

        this.style.pointerEvents = '';
    }

    async remove(removeFromWishlist = true, fireEvent = true, transition = true) {
        if (transition) {
            this.classList.add('transition-out');
            setTimeout(() => {
                this.classList.remove('transition-out');
                this.classList.add('hide');
            }, 250);
        }
        else this.classList.add('hide');

        if (removeFromWishlist) await wishlist.remove(this.id);
        if (this.querySelector('.wishlist-item__bundle-items.expanded')) this.toggleBundleItems();
        if (fireEvent) this.dispatchEvent(new CustomEvent('wishlistitemremove', {bubbles: true, detail: {item: this}}));
    }

    init() {
        this.querySelector('.wishlist-item__atc').addEventListener('click', async e => {
            let btn = e.currentTarget;
            if (!e.currentTarget.dataset.variant) {
                // Show size selector, then wait for close. If size selected, add to cart
                this.style.setProperty('--atc-top', `${btn.offsetTop}px`);
                btn.classList.add('toggled');
                this.classList.add('wishlist-item--atc-open');
                await this.querySelector('variant-selector').triggerDropdowns();
                btn.classList.remove('toggled');
                setTimeout(() => {
                    if (btn.dataset.variant && btn.dataset.variant.soldOut != 'true' && btn.dataset.preorder != 'true') this.addToCart();  
                }, 100);
                setTimeout(() => this.classList.remove('wishlist-item--atc-open'), 300);
            }
            else this.addToCart();
        });

        this.querySelector('.wishlist-item__remove').addEventListener('click', async e => {
            e.preventDefault();
            await this.remove();
        });

        this.querySelector('.wishlist-item__qty-increase').addEventListener('click', e => {
            this.quantity += 1;
            this.querySelector('.wishlist-item__qty-count').innerHTML = this.quantity;
        });

        this.querySelector('.wishlist-item__qty-decrease').addEventListener('click', e => {
            this.quantity = Math.max(1, this.quantity - 1);
            this.querySelector('.wishlist-item__qty-count').innerHTML = this.quantity;
        });

        let bundleToggle = this.querySelector('.wishlist-item__toggle-bundle');
        if (bundleToggle) {
            this.querySelector('.wishlist-item__toggle-bundle').addEventListener('click', e => this.toggleBundleItems());
        }

        // 'View Cart' button on cart signifier popup
        this.querySelector('.cart-signifier .signifier-cart').addEventListener('click', e => {
            e.preventDefault();
            window.showCartDrawer(true);
            e.currentTarget.closest('.cart-signifier').classList.remove('active');
        });

        setTimeout(() => this.classList.remove('fade-in'), 500);

        // Set size selector and product link to previously selected variant if present in data
        let savedData = wishlist.getItem(this.id);
        if (savedData && savedData.variant) {
            this.dataset.variant = savedData.variant;
            this.wishlistData.variant = savedData.variant;

            let selector = this.querySelector('size-selector');
            if (selector) {
                if (selector.selectSize) selector.selectSize(savedData.variant);
                else selector.dataset.selected = savedData.variant;
            }
        }
    }

    toggleBundleItems() {
        let btn = this.querySelector('.wishlist-item__toggle-bundle')
        if (btn.name == 'show') {
            btn.name = 'hide';
            btn.innerHTML = `Hide ${btn.dataset.type} Items`;
            this.querySelector('.wishlist-item__bundle-items').classList.add('expanded');
        }
        else {
            btn.name = 'show';
            btn.innerHTML = `View ${btn.dataset.type} Items`;
            this.querySelector('.wishlist-item__bundle-items').classList.remove('expanded');
        }
    }

    canAddToCart() {
        return (this.dataset.variant || !this.querySelector('size-selector'))
    }
}

class WishlistContents extends HTMLElement {
    constructor() {
        super();

        window.addEventListener('wishlistadd', e => this.addItem(e.detail.item));
        window.addEventListener('wishlistremove', e => this.removeItem(e.detail.id));
        document.addEventListener('wishlistitemremove', e => this.update());
        document.addEventListener('wishlistitemadd', e => this.update());
        document.addEventListener('sizechange', e => this.update());
        this.addEventListener('wishlistitematc', e => this.update());
        this.addEventListener('wishlistitemloaded', e => this.update());
        
        window.addEventListener('wishlistavailability', e => {
            if (e.detail.removedItems.length > 0) {
                // Show notification about removed items
                const count = e.detail.removedItems.length;
                const message = `${count} item${count > 1 ? 's' : ''} that ${count > 1 ? 'are' : 'is'} no longer available ${count > 1 ? 'have' : 'has'} been removed from your wishlist.`;
                
                // Create and show notification
                const notification = document.createElement('div');
                notification.className = 'wishlist-notification';
                notification.innerHTML = `
                    <div class="wishlist-notification__content">
                        <p>${message}</p>
                        <button class="wishlist-notification__close">×</button>
                    </div>
                `;
                
                document.body.appendChild(notification);
                
                // Add event listener to close button
                notification.querySelector('.wishlist-notification__close').addEventListener('click', () => {
                    notification.remove();
                });
                
                // Auto-remove after 5 seconds
                setTimeout(() => {
                    notification.remove();
                }, 5000);
            }
        });

        this.querySelector('button[name="clear"]').addEventListener('click', async e => {
            this.querySelectorAll('wishlist-item, wishlist-item-byob').forEach(item => item.classList.add('clearing'));
            let btn = e.currentTarget;
            btn.disabled = true;
            btn.classList.add('show-loading');

            setTimeout(async () => {
                this.querySelectorAll('wishlist-item, wishlist-item-byob').forEach(async item => {
                    item.classList.remove('clearing');
                });

                await this.clear();
                btn.disabled = false;
                btn.classList.remove('show-loading');
            }, 2000);
        });

        this.querySelector('button[name="add-all"]').addEventListener('click', async e => {
            let button = e.currentTarget;
            button.classList.add('show-loading');
            let items = [...this.querySelectorAll('wishlist-item, wishlist-item-byob')];
            items.forEach(item => item.dataset.disabled = true);

            let atcInfos = items.map(item => item.getAtcInfo()).flat();
            await addAllToCart(atcInfos);

            button.classList.remove('show-loading');
            button.classList.add('added');
            window.updateCartDrawer();

            items.forEach(item => {
                item.dataset.disabled = false;
                item.classList.add('added');
            });

            setTimeout(async () => {
                button.classList.remove('added');
                this.update();
            }, 3000);
        });
    }

    update() {
        let items = wishlist.getItems();
        if (items.length == 0) this.classList.add('empty');
        else this.classList.remove('empty');
        this.querySelector('.wishlist__item-count').innerHTML = items.length > 1 ? `${items.length} items` : '1 item';

        // Check whether all items have a selected size, then toggle 'add all' button
        let itemElems = [...this.querySelectorAll('wishlist-item:not(.added):not(.hide), wishlist-item-byob:not(.added):not(.hide)')];
        let canAdd = itemElems.filter(item => typeof item.canAddToCart === 'function' ? item.canAddToCart() : false);
        if (canAdd.length > 1 && canAdd.length == itemElems.length) this.dataset.allSelected = true;
        else this.dataset.allSelected = false;
    }

    async connectedCallback() {         
        let items = wishlist.getItems();
        this.update();

        let itemsElem = this.querySelector('.wishlist-items'); 
        let existing = [...itemsElem.querySelectorAll('wishlist-item, wishlist-item-byob')];
        let existingIds = existing.map(item => item.dataset.id);

        // Remove any items on page that aren't in localStorage
        // Eg, can happen for logged in user if recently removed, but not updated on server yet
        for (let item of existing) {
            if (!items.find(i => i.id.toString() == item.dataset.id)) {
                item.classList.add('transition-out');
                setTimeout(() => item.classList.add('hide'), 300);
            }
        }

        // Add placeholders for any items we need to render dynamically
        // For guest users, this is all items
        let placeholderTemplate = document.getElementById('wishlistItemPlaceholder');
        for (let item of items) {
            if (!existingIds.includes(item.id.toString())) {
                let placeholder = placeholderTemplate.content.cloneNode(true);
                placeholder.querySelector('.wishlist-item').dataset.id = item.id;
                placeholder.querySelector('.wishlist-item__name').innerHTML = item.title;
                if (item.isBundle == "true" || item.isByob) placeholder.querySelector('.wishlist-item').classList.add('is-bundle');
                if (item.isByob) placeholder.querySelector('.wishlist-item').classList.add('is-byob');

                if (item.isByob) {
                    let byobItem = document.createElement('wishlist-item-byob');
                    byobItem.dataset.id = item.id;
                    byobItem.className = placeholder.querySelector('.wishlist-item').className;
                    byobItem.innerHTML = placeholder.querySelector('.wishlist-item').innerHTML;
                    byobItem.querySelector('.wishlist-item__name').innerHTML = item.title;
                    itemsElem.appendChild(byobItem);
                }
                else itemsElem.appendChild(placeholder);
            }
        }

        // Check for unavailable products first
        await wishlist.checkAvailability();
        items = wishlist.getItems();
        
        // Fetch wishlist item partial for product from server
        let promises = items
            .filter(item => !item.isByob)
            .filter(item => !existingIds.includes(item.id))
            .map(item => [item.id, fetch(`/products/${item.handle}?view=wishlist-item${item.variant ? `&variant=${item.variant}` : ''}`)]);

        // Once downloaded, replace placeholder with actual item element
        for (let [id, promise] of promises) {
            let resp = await promise;
            if (!resp.ok) {
                if (resp.status == 404) await wishlist.remove(id);
                continue;
            }
            let placeholder = itemsElem.querySelector(`.wishlist-item--placeholder[data-id="${id}"]`);
            // Create DocumentFragment so script tags execute
            const fragment = document.createRange().createContextualFragment(await resp.text());
            placeholder.parentElement.insertBefore(fragment, placeholder);
            placeholder.remove();
        }

        //Remove any stray placeholders
        itemsElem.querySelectorAll('.wishlist-item--placeholder:not(.is-byob)').forEach(item => item.remove());

        this.update();
    }

    async addItem(item) {
        let itemsElem = this.querySelector('.wishlist-items'); 
        this.update();

        // Add placeholder
        let placeholderTemplate = document.getElementById('wishlistItemPlaceholder');
        let placeholder = placeholderTemplate.content.cloneNode(true).querySelector('.wishlist-item--placeholder');
        placeholder.querySelector('.wishlist-item__name').innerHTML = item.title;
        if (item.isBundle == "true") placeholder.querySelector('.wishlist-item').classList.add('is-bundle');
        itemsElem.insertBefore(placeholder, itemsElem.firstChild);

        // Fetch wishlist item partial for product from server
        let resp = await fetch(`/products/${item.handle}?view=wishlist-item`);

        // Once downloaded, replace placeholder with actual item element
        // Create DocumentFragment so script tags execute
        const fragment = document.createRange().createContextualFragment(await resp.text());
        placeholder.parentElement.insertBefore(fragment, placeholder);
        placeholder.remove();

        this.update();
    }

    async removeItem(id) {
        let item = this.querySelector(`wishlist-item[data-id="${id}"]:not(.transition-out):not(.hide)`);
        if (item) item.remove(false, false, false);
        this.update();
    }

    async clear() {
        window.scrollTo({top: 0, behavior: 'auto'});
        for (let item of this.querySelectorAll('wishlist-item:not(.transition-out):not(.hide), wishlist-item-byob:not(.transition-out):not(.hide)')) {
            item.remove(false);
        }
        await wishlist.clear();
        this.update();
    }
}

class WishlistUndoToast extends HTMLElement {
    constructor() {
        super();
        this.deleted = [];
        this.timeout = null;
        this.undoButton = this.querySelector('button[name="undo"]');

        this.undoButton.addEventListener('click', e => {
            e.preventDefault();
            this.undo();
        })

        this.querySelector('button[name="close"]').addEventListener('click', e => {
            this.clear();
        });

        document.addEventListener('wishlistitemremove', e => this.pushItem(e.detail.item));
        window.addEventListener('wishlistclear', e => this.querySelector('span').innerHTML = 'all items');
    }

    pushItem(item) {
        this.classList.add('show-toast');

        this.deleted.push(item);
        this.querySelector('span').innerHTML = `${this.deleted.length} item${this.deleted.length > 1 ? 's' : ''}`;
        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => this.clear(), 1000 * 60) // Clear in one minute
    }

    async undo() {
        if (this.timeout) clearTimeout(this.timeout);

        // Restore exact position of items in wishlist
        this.deleted.sort((a, b) => a.index - b.index);
        let wishlistItems = this.deleted.map(item => ({...item.wishlistData}));
        let indexes = this.deleted.map(item => item.index);
        await wishlist.addAll(wishlistItems, indexes);

        for (let item of this.deleted) {
            item.classList.remove('hide');
            item.classList.remove('fade-in');
            item.classList.add('transition-in');
            setTimeout(() => item.classList.remove('transition-in'), 300);
            // Send event to trigger wishlist contents update
            item.dispatchEvent(new CustomEvent('wishlistitemadd', {bubbles: true, detail: {item: item}}));
        }

        this.clear();
    }

    clear() {
        this.deleted = [];
        this.classList.remove('show-toast');
        if (this.timeout) clearTimeout(this.timeout);
    }
}

wishlist.load();

if (!customElements.get('wishlist-icon')) customElements.define('wishlist-icon', WishlistIcon);
if (!customElements.get('wishlist-contents')) customElements.define('wishlist-contents', WishlistContents);
if (!customElements.get('wishlist-add-button')) customElements.define('wishlist-add-button', WishlistAddButton);
if (!customElements.get('wishlist-item')) customElements.define('wishlist-item', WishlistItem);
if (!customElements.get('wishlist-undo-toast')) customElements.define('wishlist-undo-toast', WishlistUndoToast);
